import PropTypes from 'prop-types';
import React from 'react';

// Note: Using a local version of new CTA temporarily for now. Should eventually use ch.com lib version
import CTA from '../CTA/CTA';

import { getCtaProperties } from '@utils/ctaUtils';
import PreFooterCTAStyles from './PreFooterCTA.styled';

const PreFooterCTA = ({ preFooterCTA }) => {
  return (
    <PreFooterCTAStyles>
      {preFooterCTA ? (
        <div className="prefooter-cta-container">
          <CTA
            {...getCtaProperties(preFooterCTA)}
            isPreFooterCTA={true}
            // Set this false so the CTA code will evaluate the value for 'target' using getUrlTarget.
            buttonOpensToNewTab={false}
            // The figma was showing left aligned image (for mobile), but we can remove this if we decide to use contentful value.
            imageAlign="Left Side"
            customCategory={null}
            tag={null}
            subHeadingText={null}
            key="prefooter-cta"
            buttonAutomationId="prefooter-cta-button-1"
            button2AutomationId="prefooter-cta-button-2"
          />
        </div>
      ) : null}
    </PreFooterCTAStyles>
  );
};

PreFooterCTA.propTypes = {
  preFooterCTA: PropTypes.any,
};

export default PreFooterCTA;
